import qs from "qs";
import axios from "axios";
import utils from "./utils";
// import VueCookies from 'vue-cookies';
import constants from "../../../constants"
import authenService from "./authenService";
import { EventBus } from "../../../event-bus";
export default {

  getUploadAttachmentHeaders() {
    let header = {};
    let idToken = authenService.getIdToken();
    idToken && (header["Authorization"] = "Bearer " + idToken);
    let userDeptRoleId = authenService.get(
      constants.STORAGE_KEY.USER_DEPT_ROLE_ID
    );
    userDeptRoleId &&
      (header[constants.HTTP_HEADER_KEY.USER_DEPT_ROLE_ID] = userDeptRoleId);
    return header;
  },

  initConfig(config) {
    // if(!localStorage.getItem("startTime") || (new Date().getTime() - parseInt(localStorage.getItem("startTime")))/1000/60 < 30) {
    //   localStorage.setItem("startTime", new Date().getTime())
    // } else {
    //   //authenService.removeToken().then(() => {
    //       let client_id = encodeURIComponent(constants.SSO_CLIENT_ID);
    //       let redirect_uri = encodeURIComponent(constants.SSO_LOGOUT_CALLBACK);
    //       VueCookies.remove("IdHash");
    //       window.location.href = `${
    //         constants.SSO_URL_LOGOUT
    //       }?client_id=${client_id}&redirect_uri=${redirect_uri}`;
    //       localStorage.clear();
    //   //  });
    // }
    !config && (config = {});
    !config.paramsSerializer &&
      (config.paramsSerializer = function (params) {
        return qs.stringify(params, {
          arrayFormat: "repeat"
        });
      });

    !config.baseURL && (config.baseURL = constants.BASE_SERVICE_URL);

    !config.headers && (config.headers = {});

    !config.timeout &&
      (config.timeout = constants.AXIOS_REQUEST_TIMEOUT * 1000);

    let header = config.headers;

    !header["Content-Type"] && (header["Content-Type"] = "application/json");

    let idToken = authenService.getIdToken();
    idToken &&
      (header[constants.HTTP_HEADER_KEY.AUTH_HEADER_STRING] =
        "Bearer " + idToken);

    let otpToken = authenService.getOtpToken();
    idToken &&
      (header[constants.HTTP_HEADER_KEY.OTP_AUTH_HEADER_STRING] = otpToken);

    let roleCode = authenService.get(constants.STORAGE_KEY.ROLE_CODE);
    roleCode && (header[constants.HTTP_HEADER_KEY.ROLE_CODE] = roleCode);

    let deptCode = authenService.get(constants.STORAGE_KEY.DEPT_CODE);
    deptCode && (header[constants.HTTP_HEADER_KEY.DEPT_CODE] = deptCode);

    let userDeptRoleId = authenService.get(
      constants.STORAGE_KEY.USER_DEPT_ROLE_ID
    );
    userDeptRoleId &&
      (header[constants.HTTP_HEADER_KEY.USER_DEPT_ROLE_ID] = userDeptRoleId);

    return config;
  },

  post(url, data, config) {
    config = this.initConfig(config);
    return axios.post(url, data, config).catch(error => {
      this.handleGlobalError(error);
      throw error;
    });
  },

  put(url, data, config) {
    config = this.initConfig(config);
    return axios.put(url, data, config).catch(error => {
      this.handleGlobalError(error);
      throw error;
    });
  },

  get(url, config) {
    config = this.initConfig(config);
    return axios.get(url, config).catch(error => {
      this.handleGlobalError(error);
      throw error;
    });
  },

  delete(url, config) {
    config = this.initConfig(config);
    return axios.delete(url, config).catch(error => {
      this.handleGlobalError(error);
      throw error;
    });
  },

  postFile(url, data, config) {
    (!config) && (config = {});
    (!config.responseType) && (config.responseType = "blob");
    return this.post(url, data, config);
  },

  getFlie(url, config) {
    (!config) && (config = {});
    (!config.responseType) && (config.responseType = "blob");
    return this.get(url, config);
  },

  handleGlobalError(error) {
    if (utils.isErrorResponseMatch(error, constants.HTTP_STATUS.UNAUTHORIZED)) {
      EventBus.$emit(constants.EVENT_BUS.CATCH_ERROR_RESPONSE, {
        error: error
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/doc-in/services/httpService.js